class Spiral {
  constructor (canvas, settings) {
    this.canvas = canvas
    this.ctx = this.canvas.getContext('2d', { alpha: false })
    this.tempCanvas = document.createElement('canvas')
    this.tempCtx = this.tempCanvas.getContext('2d', { alpha: false })
    this.settings = settings
    this.init()
  }

  init () {
    this.currentRotation = 0
    this.animationState = 's'
    this.updateDemsnion(false)
    this.draw()
  }

  draw () {
    this.tempCtx.fillStyle = this.settings.c1
    this.tempCtx.fillRect(-this.tempCanvas.width / 2, -this.tempCanvas.height / 2, this.tempCanvas.width, this.tempCanvas.height)
    this.tempCtx.fillStyle = this.settings.c2
    this.tempCtx.strokeStyle = this.settings.c2
    this.tempCtx.lineWidth = this.settings.stroke
    this.tempCtx.beginPath()
    this.tempCtx.moveTo(0, 0)
    let radius = 0
    let angle = 0
    while (radius < this.tempCanvas.width / 2) {
      radius += this.settings.radius / 10
      angle += (Math.PI * 2) / 100
      const x = radius * Math.cos(angle)
      const y = radius * Math.sin(angle)
      this.tempCtx.lineTo(x, y)
    }
    this.tempCtx.stroke()
    this.tempCtx.closePath()
    this.tempCtx.beginPath()
    this.tempCtx.moveTo(0, 0)
    this.tempCtx.arc(0, 0, this.settings.stroke / 2, 0, Math.PI * 2)
    this.tempCtx.fill()
    this.ctx.drawImage(this.tempCanvas, -this.tempCanvas.width / 2, -this.tempCanvas.height / 2, this.tempCanvas.width, this.tempCanvas.height)
  }

  updateSettings (settings) {
    this.settings = settings
    this.draw()
  }

  updateDemsnion (draw = true) {
    this.ctx.resetTransform()
    this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2)
    const tempDemension = Math.ceil(Math.sqrt((this.canvas.width / 2) * (this.canvas.width / 2) + (this.canvas.height / 2) * (this.canvas.height / 2))) * 2
    this.tempCanvas.width = tempDemension + Math.ceil(tempDemension / 1000) * 200
    this.tempCanvas.height = tempDemension + Math.ceil(tempDemension / 1000) * 200
    this.tempCtx.resetTransform()
    this.tempCtx.translate(this.tempCanvas.width / 2, this.tempCanvas.height / 2)
    if (draw) this.draw()
  }

  animation () {
    const delta = Date.now() - this.lastRender
    this.ctx.rotate((Math.PI / 180) * (delta / 1000) * this.settings.speed * 50)
    this.ctx.drawImage(this.tempCanvas, -this.tempCanvas.width / 2, -this.tempCanvas.height / 2, this.tempCanvas.width, this.tempCanvas.height)
    this.lastRender = Date.now()
    if (this.animationState === 'r') window.requestAnimationFrame(this.animation.bind(this))
    if (this.animationState === 's') {
      this.init()
      if (this.animationStopping) this.animationStopping()
    }
  }

  startAnimation () {
    this.animationState = 'r'
    this.lastRender = Date.now()
    this.animation()
  }

  pauseAnimation () {
    this.animationState = 'p'
  }

  stopAnimation () {
    if (this.animationState === 'p') this.init()
    const promise = new Promise((resolve) => {
      if (this.animationState === 'r') {
        this.animationStopping = resolve
      } else {
        resolve()
      }
    })
    this.animationState = 's'
    return promise
  }
}

module.exports = Spiral
